const BodyModelEdit = require("./containers/BodyModelEdit");
const Authenticate = require("../utils").authenticate;

// Sync route definition
module.exports = {
    path: "/body-model/:id/edit",
    component: Authenticate(BodyModelEdit),
    exact: false
};



// WEBPACK FOOTER //
// ./src/routes/body-model-edit/index.js